import type { ReactNode } from 'react';
import { usePermissions } from '../../hooks/usePermissions';

interface PermissionGateProps {
  requires: string;
  fallback?: ReactNode;
  children: ReactNode;
}

export function PermissionGate({ requires, fallback = null, children }: PermissionGateProps) {
  const { can } = usePermissions();
  return can(requires) ? <>{children}</> : <>{fallback}</>;
}
